function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.37505 9.09687C7.07505 9.09687 8.45005 7.72187 8.45005 6.02187C8.45005 4.32187 7.07505 2.94687 5.37505 2.94687C3.67505 2.94687 2.30005 4.32187 2.30005 6.02187C2.30005 7.72187 3.67505 9.09687 5.37505 9.09687ZM5.37505 3.82187C6.57505 3.82187 7.57505 4.79687 7.57505 6.02187C7.57505 7.24687 6.60005 8.22187 5.37505 8.22187C4.15005 8.22187 3.17505 7.24687 3.17505 6.02187C3.17505 4.79687 4.15005 3.82187 5.37505 3.82187Z",
  fill: "#334156"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3751 10.1969C3.5501 10.1969 1.8001 10.9469 0.450098 12.2969C0.275098 12.4719 0.275098 12.7469 0.450098 12.9219C0.525098 12.9969 0.650098 13.0469 0.750098 13.0469C0.875098 13.0469 0.975098 12.9969 1.0501 12.9219C2.2251 11.7219 3.7501 11.0719 5.3501 11.0719C6.9251 11.0719 8.4501 11.7219 9.6501 12.9219C9.8251 13.0969 10.1001 13.0969 10.2751 12.9219C10.4501 12.7469 10.4501 12.4719 10.2751 12.2969C8.9251 10.9469 7.1751 10.1969 5.3751 10.1969Z",
  fill: "#334156"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.95 9.09692C12.925 9.09692 13.7 8.29692 13.7 7.34692C13.7 6.39692 12.9 5.59692 11.95 5.59692C11 5.59692 10.2 6.39692 10.2 7.34692C10.2 8.29692 10.975 9.09692 11.95 9.09692ZM11.95 6.44692C12.425 6.44692 12.825 6.84692 12.825 7.32192C12.825 7.79692 12.425 8.19692 11.95 8.19692C11.475 8.19692 11.075 7.79692 11.075 7.32192C11.075 6.84692 11.475 6.44692 11.95 6.44692Z",
  fill: "#334156"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5501 11.6219C14.2251 10.3719 12.3751 9.89688 10.5251 10.3719C10.3001 10.4219 10.1501 10.6719 10.2001 10.8969C10.2501 11.1219 10.5001 11.2719 10.7251 11.2219C12.2751 10.8219 13.8251 11.2219 14.9251 12.2719C15.0001 12.3469 15.1251 12.3969 15.2251 12.3969C15.3501 12.3969 15.4501 12.3469 15.5501 12.2469C15.7251 12.0719 15.7251 11.7969 15.5501 11.6219Z",
  fill: "#334156"
});
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.72b050708a1a084d301efa60cc5d6582.svg";
export { ForwardRef as ReactComponent };